module.exports = __webpack_public_path__ + "img/layout-8_1.6a83c6b7.png";